var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfsell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "CheckOut",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,16.25c-.41,0-.75,.34-.75,.75,0,.69-.56,1.25-1.25,1.25H5c-.69,0-1.25-.56-1.25-1.25v-7.25h12.5v1.25c0,.41,.34,.75,.75,.75s.75-.34,.75-.75V6c0-.96-.79-1.75-1.75-1.75h-1.25v-1.25c0-.41-.34-.75-.75-.75s-.75,.34-.75,.75v1.25H6.75v-1.25c0-.41-.34-.75-.75-.75s-.75,.34-.75,.75v1.25h-1.25c-.96,0-1.75,.79-1.75,1.75v11c0,1.52,1.23,2.75,2.75,2.75H15c1.52,0,2.75-1.23,2.75-2.75,0-.41-.34-.75-.75-.75ZM4,5.75h1.25v.25c0,.41,.34,.75,.75,.75s.75-.34,.75-.75v-.25h6.5v.25c0,.41,.34,.75,.75,.75s.75-.34,.75-.75v-.25h1.25c.14,0,.25,.11,.25,.25v2.25H3.75v-2.25c0-.14,.11-.25,.25-.25Z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.53,13.47l-2-2c-.29-.29-.77-.29-1.06,0s-.29,.77,0,1.06l.72,.72h-7.19c-.41,0-.75,.34-.75,.75s.34,.75,.75,.75h7.19l-.72,.72c-.29,.29-.29,.77,0,1.06,.15,.15,.34,.22,.53,.22s.38-.07,.53-.22l2-2c.29-.29,.29-.77,0-1.06Z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfsell);
export default __webpack_public_path__ + "static/media/mfsell.ea80e1fe8b9524883a628c992c688c97.svg";
export { ForwardRef as ReactComponent };